/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Who_BodyInputs */

const en_fw_guide_who_body = /** @type {(inputs: Fw_Guide_Who_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`david production animates the Firefly Wedding anime. Takahiro Kamei directs, Yūko Kakihara handles series composition, Yukiko Aikei designs the characters and Nogrid writes the score. Lynn voices Satoko and Kōki Uchiyama voices Shinpei. iri sings the opening theme “Period,” her first anime tie-in, and TOOBOE performs the ending “Yumegokochi.”`)
};

const zh_fw_guide_who_body = /** @type {(inputs: Fw_Guide_Who_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁动画由 david production 制作，监督亀井隆広，系列构成柿原優子，角色设计愛敬由紀子，音乐 Nogrid。Lynn 为紗都子配音，内山昂輝为進平配音。片头曲是 iri 首次为动画献唱的《Period》，片尾曲由 TOOBOE 演唱《夢心地》。`)
};

/**
* | output |
* | --- |
* | "david production animates the Firefly Wedding anime. Takahiro Kamei directs, Yūko Kakihara handles series composition, Yukiko Aikei designs the characters an..." |
*
* @param {Fw_Guide_Who_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_who_body = /** @type {((inputs?: Fw_Guide_Who_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Who_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_who_body(inputs)
	return zh_fw_guide_who_body(inputs)
});
export { fw_guide_who_body as "fw.guide.who.body" }